import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { constants } from '../../assets/constants';

@Injectable({
  providedIn: 'root'
})
export class WorkoutService {

  private urlGetWorkout = constants.urlAPI + constants.endpoints.workout.get;

  constructor(public http: HttpClient) { }

  public getWorkout(workoutId: any): Observable<any> {
    return this.http.get(this.urlGetWorkout.replace(':id', workoutId.toString()));
  }
}
